import { render } from "./IniFileSetting.vue?vue&type=template&id=7ff4cd16"
import script from "./IniFileSetting.vue?vue&type=script&lang=js"
export * from "./IniFileSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__